<template>
	<div id="app">
		<a-layout id="components-layout-demo-custom-trigger" v-if="!login">
			<a-layout-sider :trigger="null" collapsible v-model="collapsed" style="box-shadow:  5px 2px 10px 0px #dfdfdf;min-height: 100vh;z-index: 101"
			 theme="dark" width="250">
				<div class="logo">
					<span slot="title">
						<span v-if="!collapsed">
							<a-avatar shape="square" :src="info.weblogo" size="large" /> {{info.webname}}</span>
						<span v-if="collapsed">
							<a-avatar shape="square" :src="info.weblogo" size="large" /></span>
					</span>
				</div>
				<sider-nav></sider-nav>
			</a-layout-sider>
			<a-layout>
				<a-layout-header style="background: #fff;padding:0;box-shadow:  0px 2px 7px 0px #dfdfdf;z-index: 100;">
					<a-row type="flex" justify="space-between">
						<a-col>
							<a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="()=> collapsed = !collapsed" />
						</a-col>
						<a-col>
							<a-badge :count="orderNum">
								<a-button @click="toPage('/order/orderList')">新订单</a-button>
							</a-badge>
							<!-- <a-badge :count="orderNum.dhx" style="margin-left: 30px;">
								<a-button @click="toPage('/order/orderList?status=3')">待核销订单</a-button>
							</a-badge> -->
							<a-dropdown style="padding-right: 1rem;padding-left: 3rem;">
								<a class="ant-dropdown-link" href="#">
									欢迎！ {{adminName}}
									<a-icon type="down" />
								</a>
								<a-menu slot="overlay">
									<a-menu-item key="系统设置" @click="toPage('/config')" v-if="mySf =='platformAdmin'">系统设置
									</a-menu-item>
									<!-- <a-menu-item key="1">
                    <a target="_blank" rel="noopener noreferrer" href="http://www.taobao.com/">2nd menu</a>
                  </a-menu-item> -->
									<a-menu-divider v-if="mySf =='platformAdmin'" />
									<a-menu-item key="3" @click="out">退出登录</a-menu-item>
								</a-menu>
							</a-dropdown>
						</a-col>
					</a-row>
				</a-layout-header>
				<a-layout-content>
					<router-view />
				</a-layout-content>
				<a-layout-footer style="textAlign: center">
					技术支持 聚合大鱼科技
				</a-layout-footer>
			</a-layout>
		</a-layout>
		<div v-if="login">
			<router-view />
		</div>

		<a-modal v-model="couponAppliedModal" title="核销优惠券" :footer="null">
			<a-form-model layout="inline" ref="couponAppliedForm" :model="couponAppliedForm">
				<a-form-model-item>
					<a-input placeholder="请输入核销码" style="width: 300px" v-model="couponAppliedForm.code" />
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" @click="searchCouponSubmit">
						查询
					</a-button>
				</a-form-model-item>
				<template v-if="couponInfo">
					<a-card title="优惠券" style="margin-top: 20px; background: #f9f0ff;">
						<span slot="extra" style="font-size: 26px;">
							<span v-if="couponInfo.yhqInfo.status == 1" style="color: #73d13d;">待核销</span>
							<span v-if="couponInfo.yhqInfo.status  == 2" style="color: #ffc53d;">未开始</span>
							<span v-if="couponInfo.yhqInfo.status  == 3" style="color: #bfbfbf;">已过期</span>
							<span v-if="couponInfo.yhqInfo.status  == 4" style="color: #bfbfbf;">已核销</span>
						</span>
						<div style="display: flex;justify-content: space-between;">名称 <strong>{{couponInfo.yhqInfo.couponName}}</strong></div>
						<div style="display: flex;justify-content: space-between;">类型 <a-tag color="blue">{{couponInfo.yhqInfo.couponType}}</a-tag>
						</div>
						<div style="display: flex;justify-content: space-between;">内容 <strong>{{couponInfo.yhqInfo.couponCont}}</strong></div>
						<div style="display: flex;justify-content: space-between;">有效期 <strong>{{couponInfo.yhqInfo.couponBegin}} 至
								{{couponInfo.yhqInfo.couponEnd}}</strong></div>
						<a-divider dashed />
						<div style="display: flex;justify-content: space-between;">领券人 <strong>
								<a-avatar :src="couponInfo.userInfo.headpic" />
								{{couponInfo.userInfo.nickname}}</strong>
						</div>
						<div style="display: flex;justify-content: space-between;">领券时间 <strong>{{couponInfo.yhqInfo.addTime}}</strong></div>
						<div style="margin-top: 20px;text-align: center;" v-if="couponInfo.yhqInfo.status == 1">
							<a-button type="primary" size="large" @click="enterApplied">核销</a-button>
						</div>

					</a-card>
				</template>

			</a-form-model>
		</a-modal>
    
    <a-modal v-model:visible="orderNumModal" title="新订单" @ok="toOrder"
      @cancel="orderNumModal=false" ok-text="查看订单" cancel-text="取消">
      <div style="font-size: 24px;">
        当前新订单数量为 {{orderNum}}
      </div>
    </a-modal>


	</div>
</template>

<script>
	import https from '@/https.js'
	import siderNav from '@/components/siderNav.vue'
	var storage = window.localStorage
  var timer = ''
	export default {
		name: 'app',
		components: {
			siderNav
		},
		data() {
			return {
				collapsed: false,
				defaultSelect: '1',
				breadcrumbArr: [{
					title: '首页',
					url: '/home'
				}],
				login: true,
				orderNum: '',
				info: '',
				adminName: '',
				mySf: '',
				myId: '',
				couponAppliedModal: false,
				couponAppliedForm: {},
				couponInfo: '',
				appliedId:'',
        audio: new Audio(),
        isGetAudioFirst: true,
        orderNumModal: false,
			}
		},
		mounted() {
			if (storage.breadcrumbArr) {
				this.breadcrumbArr = JSON.parse(storage.breadcrumbArr)
				this.defaultSelect = storage.defaultSelect
			}
			if (storage.loginStatus == 1) {
				// this.getInfo()
				this.login = false
			} else {
				this.login = true
				this.$router.push('/login')
			}
      clearInterval(timer)
      timer = setInterval(()=>{
        if(this.$route.path!='/login') {
          this.getCount()
        }
      },20000)
			this.getInfo()
			this.mySf = storage.mySf;
			this.myId = storage.myId;
			this.adminName = storage.myName;
		},
		watch: {
			$route(to, from) {
				if (storage.loginStatus == 1) {
					// this.getInfo()
					this.login = false
				} else {
					this.login = true
					this.$router.push('/login')
				}
				if(this.$route.path!='/login') {
				  this.getCount()
				}
				this.mySf = storage.mySf;
				this.myId = storage.myId;
				this.adminName = storage.myName;
			}

		},
		methods: {
      toOrder() {
        this.orderNumModal = false
        this.$router.push('/order/orderList')
      },
      
			showCouponAppliedModal(){
				this.couponAppliedModal = true
				this.couponInfo = ''
			},
			
			enterApplied() {
				var f = this
				this.$confirm({
					title: '确认是否核销?',
					okText: '确认',
					okType: 'success',
					cancelText: '取消',
					onOk() {
						https.post('/admin/index.php/admin/Acit/hxCoupon', {
							id: f.appliedId
						}).then(res => {
							if (res.data.code == 1) {
								f.$message.success('核销成功！')
								f.searchCouponSubmit()
							} else {
								f.$message.error(res.data.msg)
							}
						})
					},
					onCancel() {},
					class: 'test',
				});
			},

			searchCouponSubmit() {
				https.post('/admin/index.php/admin/Acit/codeGetInfo', {
					code: this.couponAppliedForm.code
				}).then(res => {
					if (res.data.code == 1) {
						this.couponInfo = res.data.data
						this.appliedId = res.data.data.id
					}
				})
			},

			getCount() {
				https.get('/admin/index.php/admin/shop/tzOrder').then((res) => {
					if (res.data.code == 1) {
						this.orderNum = res.data.data.lookNum
            if(this.isGetAudioFirst) {
              this.isGetAudioFirst = false
              this.orderNumModal = true
            }
            if(res.data.data.tz=='') {
              this.audio.src = ''
            } else {
              this.audio.autoplay = true
              this.audio.src = require('./assets/tishi.mp3')
            }
					}
				}).catch(err => {
					console.log(err)
				})
			},
			getInfo() {
				https.get('/admin/index.php/admin/config/webConfig').then((res) => {
					if (res.data.code == 1) {
						console.log(res.data)
						this.info = res.data.data
					}
				}).catch(err => {
					console.log(err)
				})
			},
			out() {
				https.post('/admin/index.php/admin/index/logOut', {
					token: storage.token
				}).then((res) => {
					if (res.data.code == 1) {
						storage.clear()
						this.$router.push('/login')
					}
				}).catch(err => {
					console.log(err)
				})

			},
			toPage(e) {
				if (e != '') {
					this.$router.push(e)
				}
			},
			selectMenu(e) {
				storage.defaultSelect = e.key
				this.defaultSelect = e.key
				var bcArr = []
				for (var i = e.keyPath.length - 1; i >= 0; i--) {
					var obj = {
						title: e.keyPath[i].split('#')[1],
						url: e.keyPath[i].split('#')[2]
					}
					bcArr.push(obj)
				}
				this.breadcrumbArr = bcArr
				storage.breadcrumbArr = JSON.stringify(bcArr)
			},
		}
	}
</script>

<style lang="less">
	#components-layout-demo-custom-trigger .trigger {
		font-size: 18px;
		line-height: 64px;
		padding: 0 24px;
		cursor: pointer;
		transition: color .3s;
	}

	#components-layout-demo-custom-trigger .trigger:hover {
		color: #1890ff;
	}

	#components-layout-demo-custom-trigger .logo {
		height: 64px;
		line-height: 64px;
		text-align: center;
		color: #fff;
		font-weight: 500;
		font-size: 1rem;
	}

	.breadcrumbClass:hover {
		cursor: pointer;
	}

	.font-danger {
		color: #f5222d
	}

	.font-warning {
		color: #FFCC33;
	}

	.font-success {
		color: #66CC00;
	}

	.mainBox {
		padding: 20px;
	}

	.searchBox {
		background: #fff;
		padding: 20px;
		margin-bottom: 20px;
	}

	.contentBox {
		background: #fff;
		padding: 20px;
	}
		
	.text-gray{
		color:#bfbfbf
	}
</style>
